import {h, Fragment} from "preact"
import Product from "./Product";
import { useAppState } from "@nosto/preact";
import { useEffect } from "preact/hooks";

export default function Products() {
  const {
    response: { products },
    loading,
  } = useAppState();

  useEffect(() => {
    Nosto.migrateToShopifyMarket({
      productSectionElement: ".ns-serp .nosto-product-info",
      productHandleAttribute: "x-nosto-handle",
      priceElement: ".ns-serp .nosto-newprice",
      listPriceElement: ".ns-serp .nosto-oldprice",
    });
  }, [products?.hits]);

  useEffect(() => {
    if(window.innerWidth < 1025){
      document.querySelectorAll(".ns-product").forEach((card) => {
        let carousel = new Flickity(card.querySelector('.ns-image-outer'), {
          freeScroll: false,
          // prevNextButtons: true, 
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          cellAlign: 'left',
          contain: true,
          imagesLoaded: true,
        })
      })
    }
  }, [products])

  // console.log("products", products)

  useEffect(() => {
    if (!loading) {
        if(window.frcp) frcp.wishlist.attachOnCollection()
    }
  }, [loading])  

  return (
    <ul
      class="ns-products-container ns-d-flex ns-flex-wrap ns-list-unstyled"
      style={loading ? "opacity: 0.3;" : ""}
    >
      {products.hits.map((hit, index) => {
        return <Product product={hit} key={hit.productId || index} />;
      })}
    </ul>
  );
}
